import MelhousBoard from "../Components/MelhousBoard";
import MelhousPage from "../Components/MelhousPage";
import ModelPqrs from "../models/ModelPqrs";
import { VIEW_PQRS } from "../constants";

function MelhousPqrs() {
  return (
    <MelhousPage view={VIEW_PQRS}>
      <MelhousBoard model={ModelPqrs} />
    </MelhousPage>
  );
}

export default MelhousPqrs;
